import { render } from "./InEvidenceList.vue?vue&type=template&id=3c2fb5d2"
import script from "./InEvidenceList.vue?vue&type=script&lang=js"
export * from "./InEvidenceList.vue?vue&type=script&lang=js"

import "./InEvidenceList.vue?vue&type=style&index=0&id=3c2fb5d2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__